import { createTicket } from "library/api/zendesk/zendesk";
import { getIsProduction } from "library/browser";
import {
  transactionDisputeCustomFieldsAu,
  transactionDisputeCustomFieldsNZ,
} from "library/zendeskAPI/customFieldsMap";
import { GetTransactionDisputeParams } from "../../components/TransactionDispute/types";
import { Field } from "../api/zendesk/types.generated";
import { formatDate } from "./zendeskAPI";

const FORM_ID_AU = { prod: 360000124497, nonProd: 360000242698 };
const FORM_ID_NZ = { prod: 360000132777, nonProd: 360000242798 };

const GROUP_ID_AU = { prod: 360002312898, nonProd: 360004390118 };
const GROUP_ID_NZ = { prod: 360002369658, nonProd: 360004390538 };

export async function createTransactionDisputeTicket({
  userName,
  email,
  firstName,
  lastName,
  dateOfBirth,
  address,
  suburb,
  state,
  postCode,
  mobileNumber,
  typeOfDispute,
  description,
  transactions,
  last4Digits,
  isNZ,
  token,
}: GetTransactionDisputeParams) {
  const isProduction = getIsProduction();
  const envKey = isProduction ? "prod" : "nonProd";
  const transactionFields = Object.values(transactions).reduce(
    (acc: Field[], cur, index) => {
      acc.push(
        {
          id: transactionDisputeCustomFieldsAu[`Transaction Date ${index + 1}`],
          value: formatDate(cur.date),
        },
        {
          id: transactionDisputeCustomFieldsAu[`Merchant Name ${index + 1}`],
          value: cur.merchant,
        },
        {
          id: transactionDisputeCustomFieldsAu[
            `Transaction Amount ${index + 1}`
          ],
          value: cur.amount,
        },
      );
      return acc;
    },
    [],
  );
  const numberOfTransactions = Object.keys(transactions).length;
  const ticketResponse = await createTicket(
    {
      isNZ,
      requester: {
        email,
        name: userName,
      },
      ticketFormId: isNZ ? FORM_ID_NZ[envKey] : FORM_ID_AU[envKey],
      groupId: isNZ ? GROUP_ID_NZ[envKey] : GROUP_ID_AU[envKey],
      subject: "Transaction dispute",
      comment: description,
      customFields: [
        {
          id: transactionDisputeCustomFieldsAu["Customers first name"],
          value: firstName,
        },
        {
          id: transactionDisputeCustomFieldsAu[
            "Surname  (as it appears on ID)"
          ],
          value: lastName,
        },

        {
          id: transactionDisputeCustomFieldsAu.DOB,
          value: formatDate(dateOfBirth),
        },
        {
          id: transactionDisputeCustomFieldsAu["Mobile Number"],
          value: mobileNumber,
        },
        {
          id: transactionDisputeCustomFieldsAu["Relationship to account"],
          value: "account_holder",
        },
        {
          id: transactionDisputeCustomFieldsAu["Last 4 digits"],
          value: last4Digits,
        },
        {
          id: transactionDisputeCustomFieldsAu["Privacy Acknowledgement"],
          value: true,
        },
        {
          id: transactionDisputeCustomFieldsAu["Number of transactions"],
          value: `transactions_${
            numberOfTransactions === 15 ? "15_or_more" : numberOfTransactions
          }`,
        },
        { id: transactionDisputeCustomFieldsAu.Address, value: address },
        {
          id: transactionDisputeCustomFieldsAu["Suburb or City"],
          value: suburb,
        },
        {
          id: isNZ
            ? transactionDisputeCustomFieldsNZ["Province/Region"]
            : transactionDisputeCustomFieldsAu.State,
          value: state,
        },
        {
          id: transactionDisputeCustomFieldsAu["Postcode AU/NZ"],
          value: postCode,
        },
        {
          id: transactionDisputeCustomFieldsAu["Type of dispute "],
          value: typeOfDispute,
        },
        ...transactionFields,
      ],
    },
    token,
  );

  return ticketResponse.data.ticket_id;
}
